export enum ExportFormat {
    Png = "Png",
    Pdf = "Pdf",
    Excel = "Excel",
    Csv = "Csv",
    GeoJson = "GeoJson",
    Dwg = "Dwg",
    Kml = "Kml"
}